import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@shared/services';
import { map } from 'rxjs';


export const loginGuard = () => {
    const authService = inject(AuthService);
    const router = inject(Router);

    return authService.token.pipe(map(tokenId => {
        if (tokenId !== '') {
            return router.parseUrl('/');
        }
        return true;
    }));
}
